import { CenteredMessagePage } from "@components/CenteredMessagePage"
import { useRouteShellContext } from "@components/routeShellContext"
import { SiteShell } from "@components/SiteShell"
import * as m from "@paraglide/messages"
import { createFileRoute, redirect } from "@tanstack/react-router"
import { isSupportedLocale } from "@utils/locale"
import { localizedRouteHead } from "@utils/routeHead"

export const Route = createFileRoute("/$locale/contact/thanks")({
  beforeLoad: ({ params }) => {
    if (!isSupportedLocale(params.locale)) throw redirect({ to: "/404" })
  },
  head: ({ params }) => {
    const locale = params.locale as "en" | "ja"
    return localizedRouteHead({
      locale,
      page: "contact",
      path: `/${locale}/contact/thanks`,
      robots: "noindex,nofollow",
    })
  },
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <SiteShell page="thanks">
      <ContactThanksPage />
    </SiteShell>
  )
}

export function ContactThanksPage() {
  const { locale } = useRouteShellContext()
  return (
    <CenteredMessagePage
      className="contact-form-thanks"
      title={m.contact_page_thanks({}, { locale: locale })}
      linkHref="/"
      linkLabel={m.back_toHome({}, { locale: locale })}
    >
      <p>{m.contact_page_thanksDescription({}, { locale: locale })}</p>
    </CenteredMessagePage>
  )
}
